import React, { useEffect, useState, useRef } from "react";
import kairoslogo from '../assets/images/kairos-logo.png';
import callicon from '../assets/images/call-icon.png';
import {  Modal } from "react-bootstrap";
import { apiUrl, assetsUrl } from "../config/Config";
import axios from "axios";
import Swal from 'sweetalert2';
import AOS from "aos";
import 'aos/dist/aos.css';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Drawer, List, ListItem, ListItemText, Button } from '@mui/material';
import { faPlus, faMinus, faXmark, faBars, faHandshake, faAward, faCircleCheck, faCubes, faClipboardCheck, faFilePdf, faCircleDown } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useParams } from 'react-router-dom';
import whatsappsvg from '../assets/images/whatsapp.svg';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
// import required modules
import {Autoplay, Pagination } from 'swiper/modules';
import footerroundimg from '../assets/images/roundlogo.png';


const ProductsOffered = () => {
    const pagination = {
        clickable: true,
      };
    const navigate = useNavigate();
    // const { title, id } = useParams();
   const faqsprevdata = [
    {isshow: true, question: "The expense windows adapted sir. Wrong widen drawn.", answer: "Offending belonging promotion provision an be oh consulted ourselves it. Blessing welcomed ladyship she met humoured sir breeding her. "},
    {isshow: false, question: "Six curiosity day assurance bed necessary?", answer: "Offending belonging promotion provision an be oh consulted ourselves it. Blessing welcomed ladyship she met humoured sir breeding her. "},
    {isshow: false, question: "Produce say the ten moments parties?", answer: "Offending belonging promotion provision an be oh consulted ourselves it. Blessing welcomed ladyship she met humoured sir breeding her. "},
    {isshow: false, question: "Simple innate summer fat appear basket his desire joy?", answer: "Offending belonging promotion provision an be oh consulted ourselves it. Blessing welcomed ladyship she met humoured sir breeding her. "},
   ]
   const [showIcon, setShowIcon] = useState(true);
   const [showenquiremodal, setshowenquiremodal] = useState(false);
   const [fullname, setfullname] = useState("");
   const [email, setemail] = useState("");
   const [number, setnumber] = useState("");
   const [message, setmessage] = useState("");
   const [showloading, setshowloding] = useState(false);

   const [faqsdata, setfaqsdata] = useState(faqsprevdata);
   const [forceupdatestate, setforceupdatestate] = useState(false);
   const [activesection, setactivesection] = useState('');
   const faqsdataRef = useRef([]);
   faqsdataRef.current = faqsdata;

   const homeRef = useRef(null);
   const aboutRef = useRef(null);
   const serviceRef = useRef(null);
   const faqRef = useRef(null);
   const contactRef = useRef(null);

   const [allservices, setallservices] = useState([]);
   const [selectedservice, setselectedservice] = useState({});
   const selectedserviceRef = useRef();
   selectedserviceRef.current = selectedservice;
   const [showservicemodal, setshowservicemodal] = useState(false);

   const [open, setOpen] = useState(false);

   const [servicedetails, setservicedetails] = useState({});

   const servicedetailsRef = useRef(null);
   servicedetailsRef.current = servicedetails;

   const toggleDrawer = (state) => {
    setOpen(state);
  };

//    const fetallservices = async(id) => {
//     var data = {
//         id: id
//     }
//       const headers = {
//         headers: {
//           "Content-Type": "application/json"
//         },
//       };
//       let resp = await axios
//         .post(apiUrl + "usergetservicedetails",data, headers)
//         .then((res) => {
//           // console.log('res >>>', res.data)
//           if (res.data.status == "success") {
//             if(Object.keys(res.data?.data)?.length > 0) {
//                 setservicedetails(res.data?.data);
//             } else {
//                 setservicedetails({})
//             }
            
//             setshowloding(false);
//           } else {
            
//             setshowloding(false);
//           }
//         })
//         .catch((err) => {
//           setshowloding(false);
//           alert(err.message);
//         });
//    }

const fetallservices = async() => {
    const headers = {
      headers: {
        "Content-Type": "application/json"
      },
    };
    let resp = await axios
      .get(apiUrl + "userallservices", headers)
      .then((res) => {
        // console.log('res >>>', res.data)
        if (res.data.status == "success") {
          if(res.data?.data?.length > 0) {
            setallservices(res.data?.data)
          } else {
            setallservices([])
          }
          
          setshowloding(false);
        } else {
          
          setshowloding(false);
        }
      })
      .catch((err) => {
        setshowloding(false);
        alert(err.message);
      });
 }

 const [announcemnetdetails, setannouncemnetdetails] = useState({});

 const fetchallannouncements = async() => {
    const headers = {
        headers: {
          "Content-Type": "application/json"
        },
      };
      let resp = await axios
        .get(apiUrl + "userallannouncements", headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {

            if(res?.data?.data?.length > 0) {
                setannouncemnetdetails(res?.data?.data[0]);
            } else {
                setannouncemnetdetails({});
            }
            
            
            // setshowloding(false);
          } else {
            
            // setshowloding(false);
          }
        })
        .catch((err) => {
        //   setshowloding(false);
          alert(err.message);
        });
 }

   const submithandle = async() => {
    if(fullname && email && number) {
      var data = {
        fullname: fullname,
        email: email,
        number: number,
        message: message
      }
      const headers = {
        headers: {
          "Content-Type": "application/json"
        },
      };
      let resp = await axios
        .post(apiUrl + "createenquire", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            Swal.fire({
              title: '',
              text: "Enquired Successfully",
              icon: 'success',
              customClass: {
                icon: 'custom-swal-icon' // Apply the custom class
              },
              width: '350px',
              confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
              customClass: {
                  popup: "small-icon-alert",
                },
            });
            setshowenquiremodal(false);
            setfullname("");
            setemail("");
            setnumber("");
            setmessage("");
            setshowloding(false);
          } else {
            
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
      setshowloding(false);
    } else {
      alert('Enter all required fields');
    }
   }

   const handlefaqtoggle = (index, currentstatus) => {
    var prevdata = faqsdataRef.current;
    var newdata = [];
    for(var i = 0; i < prevdata?.length; i++) {
      if(i == index) {
        var obj = prevdata[i];
        obj.isshow = !currentstatus;
        newdata.push(prevdata[i]);
      } else {
        var obj = prevdata[i];
        obj.isshow = false;
        newdata.push(prevdata[i]);
      }
    }
    setfaqsdata(newdata);
    setforceupdatestate(!forceupdatestate);
   }

   const [sticky, setSticky] = useState("");
     const isSticky = () => {
       /* Method that will fix header after a specific scrollable */
       const scrollTop = window.scrollY;
       const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
       setSticky(stickyClass);
       console.log(stickyClass);
     };
     const classes = `main-header-div ${sticky} mobhide`;

     const scrollToHome = () => {
      if (homeRef.current) {
        const topOffset = homeRef.current.offsetTop; // adjust 80 for your header
        window.scrollTo({ top: topOffset, behavior: 'smooth' });
        setactivesection('Home');
        setOpen(false);
      }
    };

    const scrollToAbout = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 : window.innerWidth <= 1024 ? 60 : 190;

  const y = aboutRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('Profile');
  setOpen(false);
    };

    const scrollToService = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 :  window.innerWidth <= 1024 ? 60 : 190;

  const y = serviceRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('Services');
  setOpen(false);
    };

    const scrollToFaq = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 : window.innerWidth <= 1024 ? 60 : 190;

  const y = faqRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('FAQs');
  setOpen(false);
    };

    const scrollToContact = () => {
      const isHeaderFixed = window.scrollY >= 300; // Or your header fixed condition
      console.log('isHeaderFixed >>', isHeaderFixed);
  const offset = isHeaderFixed ? 70 : window.innerWidth <= 1024 ? 60 : 190;

  const y = contactRef.current.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
  setactivesection('Contact');
  setOpen(false);
    };

    const handleserviceclick = (obj) => {
      console.log('obj >>', obj);
      setselectedservice(obj);
      setTimeout(() => {
        setshowservicemodal(true);
      }, 1000)
    }

    const handleshowenqmodal = () => {
      setfullname("");
            setemail("");
            setnumber("");
            setmessage("");
      setshowenquiremodal(true);
    }

    const handleclickproductbox = (item) => {
      console.log('item >>', item)
      window.open('/products/'+item?.title+'/'+item?.id, '_blank');
    }

    const swiperRefmodal = useRef(null);
    const [showmodal, setshowmodal] = useState(false);

    const goToSlide = (index) => {
        setshowmodal(true);
    setTimeout(() => {
      console.log('index >>', index);
    console.log('swiperRefmodal.current >>', swiperRefmodal?.current?.swiper)
    if (swiperRefmodal.current && swiperRefmodal.current.swiper) {
      swiperRefmodal.current.swiper.slideTo(index);
      // setshowmodal(true);
    }
    }, [100])
      };
    
   
    //  useEffect(() => {
    //   fetallservices();
    //   fetchallannouncements();
    //    const handleScroll = () => {
    //     if(window.innerWidth <= 1024) {
    //       return 
    //     }
    //     const scrollY = window.scrollY + 100; // Add padding to detect a bit earlier
    
    //     const sections = [
    //       { id: "Home", ref: homeRef },
    //       { id: "Profile", ref: aboutRef },
    //       { id: "Services", ref: serviceRef },
    //       { id: "FAQs", ref: faqRef },
    //       { id: "Contact", ref: contactRef },
    //     ];
    
    //     for (let section of sections) {
    //       const offsetTop = section.ref.current.offsetTop;
    //       const offsetHeight = section.ref.current.offsetHeight;
    
    //       if (scrollY >= offsetTop && scrollY < offsetTop + offsetHeight) {
    //         setactivesection(section.id);
    //         break;
    //       }
    //     }

    //     // sticky header

    //     const scrollTop = window.scrollY;
    //    const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
    //    setSticky(stickyClass);
    //    console.log(stickyClass);
    //   };

    //    window.addEventListener("scroll", handleScroll);
    //    return () => {
    //      window.removeEventListener("scroll", handleScroll);
    //    };

    //  }, []);

    const clickscrolltobottom = () => {
      window.scrollTo(0, 550);
    }

    useEffect(() => {
      const handleScroll = () => {
        setShowIcon(window.scrollY <= 500);
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);

     useEffect(() => {
      window.scrollTo(0, 0);
      fetallservices();
      fetchallannouncements();
      AOS.init();
      AOS.refresh();
     }, [])
    return (
      <>
        <div className={"main-header-div mobhide innerpagerheader"}>
          <div className="container">
            <div className="header-row">
              <div className="header-logo-div">
                <img src={kairoslogo} className="kairoslogo" />
              </div>
              <div className="header-navbar">
                <nav className="navbar navbar-expand-lg  custom-nav ">
                  <ul class="navbar-nav">
                    <li
                      className={
                        activesection == "Home" ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link to={"/"}>Home</Link>
                    </li>
                    <li
                      className={
                        activesection == "Profile"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link to={"/#Profile"}>Profile</Link>
                    </li>
                    <li
                      className={
                        activesection == "Services"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link to={"/#Products-range"}>Products Range</Link>
                    </li>
                    <li
                      className={
                        activesection == "FAQs" ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link to={"/#FAQ"}>FAQs</Link>
                    </li>
                    <li
                      className={
                        activesection == "Contact"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link to={"/#Contact"}>Contact</Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="header-number-div">
                <img src={callicon} className="calliconimg" />
                <div className="">
                  <Link to={"tel: +919819323245"} className="callicontext">
                    Mr. Sohil +91 9819323245,
                  </Link>
                  <br />
                  <Link to={"tel: +919819534178"} className="callicontext">
                    Mr. Rakesh +91 9819534178
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="deskhide">
          <div className="mobilemaindiv">
            <div
              className="mobilemenudiv"
              onClick={() => {
                setOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faBars} className="menubaricon" />
            </div>
            <img src={kairoslogo} alt="Logo" className="website-logo" />
          </div>
          <div className="navbarheight" />

          <Drawer
            anchor="left"
            open={open}
            onClose={() => {
              toggleDrawer(false);
            }}
          >
            <List sx={{ width: 250 }}>
              <div className="mobilemenusidebarmaindiv">
                <div
                  className="mobilemenusidebar-closediv"
                  onClick={() => {
                    toggleDrawer(false);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="menubariconsidebar"
                  />
                </div>
                <nav className="navbar navbar-expand-lg  custom-nav ">
                  <ul class="navbar-nav">
                    <li
                      className={
                        activesection == "Home" ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link to={"/"}>Home</Link>
                    </li>
                    <li
                      className={
                        activesection == "Profile"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link to={"/#Profile"}>Profile</Link>
                    </li>
                    <li
                      className={
                        activesection == "Services"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link to={"/#Products-range"}>Products Range</Link>
                    </li>
                    <li
                      className={
                        activesection == "FAQs" ? "nav-item active" : "nav-item"
                      }
                    >
                      <Link to={"/#FAQ"}>FAQs</Link>
                    </li>
                    <li
                      className={
                        activesection == "Contact"
                          ? "nav-item active"
                          : "nav-item"
                      }
                    >
                      <Link to={"/#Contact"}>Contact</Link>
                    </li>
                  </ul>
                </nav>
              </div>
              {/* {['Dashboard', 'Profile', 'Settings', 'Logout'].map((text) => (
            <ListItem button key={text}>
              <ListItemText primary={text} />
            </ListItem>
          ))} */}
            </List>
          </Drawer>
        </div>

        {
          showIcon ?
          <section>
          <div className="sticyscrolldownmaindiv" onClick={() => {clickscrolltobottom()}}>
          <div className="sticyscrolldowndiv">
            <FontAwesomeIcon
              icon={faCircleDown}
              className="faCircleDown-icon"
            />
          </div>
          </div>
          
        </section> :
        null
        }
        

        <section>
          {/* Whatsapp Icon */}
          <Link
            to={"https://wa.me/919819323245"}
            target="_blank"
            className="whatsappicon-div"
          >
            <img src={whatsappsvg} className="whatsapp-icon" />
          </Link>
        </section>

        <section>
          <div className="container">
            {Object.keys(announcemnetdetails)?.length > 0 ? (
              <>
                <div className="row">
                  <p className="innerpagetitle">Achievements</p>
                  <div className="innerpagetitle-border achievements-title-border"></div>
                </div>
                <div className="announcement-maindiv">
                  <div className="row">
                    <div className="col-12 col-sm-4">
                      {announcemnetdetails?.imagesarr ? (
                        <div className="images-scroll-div">
                          <Swiper
                            loop={true}
                            pagination={pagination}
                            autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                            }}
                            modules={[Autoplay, Pagination]}
                            className="mySwiper"
                          >
                            {JSON.parse(announcemnetdetails?.imagesarr)?.map(
                              (item, index) => {
                                return (
                                  <SwiperSlide>
                                    <img
                                      src={assetsUrl + "announcement/" + item}
                                      className="announcement-img"
                                      onClick={() => {
                                        goToSlide(index);
                                      }}
                                    />
                                  </SwiperSlide>
                                );
                              }
                            )}
                          </Swiper>
                        </div>
                      ) : null}
                    </div>
                    <div className="col-12 col-sm-8">
                      <div className="announcement-contentdiv">
                        <p className="announcement-title">
                          {announcemnetdetails?.title}
                        </p>
                        <p className="about-us-desc announcement-description">
                          {announcemnetdetails?.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}

            <div className="row">
              <p className="innerpagetitle">Product categories</p>
              <div className="innerpagetitle-border"></div>
            </div>
            <div className="row mt-5 justify-content-center">
              {allservices?.length > 0 ? (
                allservices?.map((item, index) => {
                  return (
                    <div className="col-12 col-sm-6 col-md-3 mb-4">
                      <div
                        className="servicebox productsofferedservicebox"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleclickproductbox(item);
                        }}
                        // data-aos="fade-up"
                        // data-aos-delay={index * 500}
                        // data-aos-duration="1000"
                      >
                        <img
                          src={assetsUrl + "services/" + item?.image}
                          className="serviceboximgbg"
                        />
                        <div className="servicetextbg">
                          <p className="oilandgastext">{item?.title}</p>
                          <div
                            className="readmoretextdiv"
                            onClick={() => {
                              handleserviceclick(item);
                            }}
                          >
                            <p className="readmoretext">Read More</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="noservice-text">Services not added.</p>
              )}
            </div>
            {/* {
                    servicedetailsRef.current?.tabledata ?
                    JSON.parse(servicedetailsRef.current?.tabledata)[0]?.title && JSON.parse(servicedetailsRef.current?.tabledata)[0]?.file ?
                <div className="productinnertable">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <td style={{width: '80%'}}><b>Title</b></td>
                                <td><b>File</b></td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                JSON.parse(servicedetailsRef.current?.tabledata)?.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.title}</td>
                                            <td>
                                                {
                                                    item?.file ?
                                                    <Link to={assetsUrl+'tablefile/'+item?.file} target="_blank" className="pdficon-div">
                                                        <FontAwesomeIcon icon={faFilePdf} style={{color: 'rgb(220, 53, 69)', fontSize: 18}} className="menubaricon" />
                                                    </Link> : "-"
                                                }
                                                
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            
                        </tbody>
                    </table>
                </div> 
                : null
                : null
                } */}
          </div>
        </section>
        <br />
        <br />

        <section ref={contactRef}>
          <div className="footermaindiv">
            <div className="container">
              <div className="footerflexrow">
                <div className="footerleftdiv1">
                  <img src={footerroundimg} className="footer-img" />
                  <p className="footer-address-text"><b>Our Presence</b> : INDIA & UAE</p>
                  <p className="footer-address-text footer-address-text1">
                    <span className="indiaheaderfooter">
                      <b>India :</b>
                    </span>
                    <span>
                     13th FLOOR, EMBASSY 247 PARK, LBS ROAD,
                    VIKHROLI WEST, MUMBAI - 400079. INDIA.
                    </span>
                  </p>
                  <p className="footer-address-text footer-address-text1">
                    <span>
                      <b>UAE :</b>
                    </span>
                    <span>
                    Dubai.
                    </span>
                  </p>
                </div>
                <div className="footermiddiv">
                  <div className="footerchilddiv">
                    <p className="footer-links-head">LINKS</p>
                    <ul className="links-div">
                      <li>
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li>
                        <Link to={"/#Profile"}>Profile</Link>
                      </li>
                      <li>
                        <Link to={"/#Products-range"}>Products range</Link>
                      </li>
                      <li>
                        <Link to={"/#FAQ"}>FAQs</Link>
                      </li>
                      <li>
                        <Link to={"/#Contact"}>Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="footerthirddiv">
                  <p className="footer-links-head">PHONE</p>
                  <p className="footer-links-text">
                    <Link to={"tel: +919819323245"} className="callicontext">
                      Mr. Sohil +91 9819323245,
                    </Link>
                    <br />
                    <Link to={"tel: +919819534178"} className="callicontext">
                      Mr. Rakesh +91 9819534178
                    </Link>
                  </p>
                  <p className="footer-links-head footer-links-email">EMAIL</p>
                  <Link
                    to={"mailto:kairosinternational24@gmail.com"}
                    className="footer-links-text mobhide"
                  >
                    kairosinternational24@gmail.com
                  </Link>
                  <Link
                    to={"mailto:kairosinternational24@gmail.com"}
                    className="footer-links-text deskhide"
                  >
                    kairosinternational24
                    <br />
                    @gmail.com
                  </Link>
                </div>
              </div>
              <p className="copyright-text">
                © Kairos International. All Rights Reserved. Website developed
                by
                <Link to={"https://www.beakmedia.com/"} target="_blank">
                  Beak Media.
                </Link>
              </p>
            </div>
          </div>
        </section>

        <div
          className="get-a-quotebtn-div"
          onClick={() => {
            handleshowenqmodal();
          }}
        >
          <p>Get A Quote</p>
        </div>

        <Modal
          show={showmodal}
          onHide={() => setshowmodal(false)}
          size="lg"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="product-details-swipper-modal">
              <Swiper
                ref={swiperRefmodal}
                style={{
                  "--swiper-navigation-color": "#fff",
                  "--swiper-pagination-color": "#fff",
                }}
                loop={true}
                pagination={pagination}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay, Pagination]}
                className="mySwiper"
              >
                {announcemnetdetails?.imagesarr &&
                  JSON.parse(announcemnetdetails?.imagesarr)?.map(
                    (item, index) => {
                      return (
                        <SwiperSlide>
                          <img
                            src={assetsUrl + "announcement/" + item}
                            className="announcement-img"
                            onClick={() => {
                              goToSlide(index);
                            }}
                          />
                        </SwiperSlide>
                      );
                    }
                  )}
              </Swiper>
            </div>
          </Modal.Body>
        </Modal>

        {/*Add modal */}
        <Modal
          show={showenquiremodal}
          onHide={() => setshowenquiremodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Get a Quote</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Full Name</label>
                <input
                  value={fullname}
                  onChange={(t) => {
                    setfullname(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Full Name"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Email</label>
                <input
                  value={email}
                  onChange={(t) => {
                    setemail(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Email"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Contact Number</label>
                <input
                  value={number}
                  onChange={(t) => {
                    setnumber(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Phone Number"
                />
              </div>

              <div className="mt-3">
                <label className="addproduct-label">Message</label>
                <textarea
                  value={message}
                  onChange={(t) => {
                    setmessage(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Message"
                ></textarea>
              </div>

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    submithandle();
                  }}
                >
                  <p>Submit</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
}

export default ProductsOffered